export default "/images/fa_send-o.svg?9329409e7bbe015121f9effd7f36da69";